export default __webpack_public_path__ + "imgs/120e6c3635b9dc3649a33af1140fa4bd.png";